<template>
    <div v-loading="loading" 
        element-loading-text="正在加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(23, 40, 90)"  style="display: flex;justify-content: center;align-items: center;width: 100%;height: 100%;padding: 2% 3%">
        <dv-scroll-ranking-board   :config="config" style="width:100%;height:100%" />
    </div>
</template>

<script>
import util from "@/util";
import store from "@/store";
import { mapState } from "vuex";
export default {
    data() {
        return{
            loading: true,
            // config: null,
            config: {
                data: [
                    {
                      name: '周口',
                      value: 55123
                    },
                    {
                      name: '南阳',
                      value: 12022
                    },
                    {
                      name: '西峡',
                      value: 78932
                    },
                    {
                      name: '驻马店',
                      value: 63411
                    },
                    {
                      name: '新乡',
                      value: 44231
                    }
                ],
                unit: 'kW·h',
                sort: true,
                waitTime: 3000,
                // rowNum: 5,
            }
        }
    },
    mounted() {
        this.getSiteOrderSummary()
    },
    watch: {
        siteOrderSummary: {
            handler(val) {
                console.log(val)
                let data = []
                for(let i = 0;i<val.length;i++) {
                    data.push({
                        name: val[i].name,
                        value: parseInt(val[i].power.toFixed(2))
                    })
                }
                this.config.data = JSON.parse(JSON.stringify(data)).concat([]); 
                this.config = { ...this.config }
            },
            deep: true,
        },
    },
    computed: {
        ...mapState(["siteOrderSummary"]),
    },
    methods: {
        async getSiteOrderSummary() {
            let date = new Date()
            let year = date.getFullYear()
            let month = date.getMonth()
            let start_time = new Date(year,month,1).getTime()
            let end_time = new Date(year,month+1,0).getTime() + 24 * 60 * 60 * 1000
            // console.log(start_time)
            // console.log(end_time)
            let that = this;
            let params = {
                postData: {
                    end_time: parseInt(end_time / 1000),
                    start_time: parseInt(start_time / 1000),
                    sum_type: 2,
                },
                callback: () => {
                   that.loading = false;
                },
            };
            await store.dispatch("getOrderSummary", params);
            // let data = []
            // for(let i = 0;i<this.siteOrderSummary.length;i++) {
            //     this.config.data.push({
            //         name: this.siteOrderSummary[i].name,
            //         value: this.siteOrderSummary[i].power
            //     })
            // }
            // this.config.data = JSON.parse(JSON.stringify(data)).concat([]); 
            // this.config = { ...this.config }
        },
    }
}
</script>

<style lang="scss" scoped>
::v-deep .rank {
    color:red;
}

::v-deep .dv-scroll-ranking-board .ranking-info .rank {
    // color: #00abf5;
    color:red;
}
::v-deep .dv-scroll-ranking-board{
    color:  #00abf5;
}
::v-deep .dv-scroll-ranking-board .ranking-column .inside-column {
    background-color: #04d0f5;
}
::v-deep .row-item {
    min-height: 3rem;
}
</style>